import {BrowserRouter as Router, Navigate, Route, Routes, ScrollRestoration, useLocation} from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import StickyAnnouncement from './components/StickyAnnouncement/StickyAnnouncement';
import Footer from './components/Footer/Footer';
import Main from './pages/Top/Main';
import TourDetailsNew from './pages/TourDetails/TourDetailsNew';
import TourList from './pages/Tours/TourList';
import ReviewList from './pages/ReviewList/ReviewList';
import About from './pages/About/About';
import Campaign from './pages/Campaign/Campaign';
import Faq from './pages/Faq/Faq';
import Policy from './pages/Policy/Policy';
import Contact from './pages/Contact/Contact';
import Privacy from './pages/Privacy/Privacy';
import ReviewAllList from './pages/ReviewAllList/ReviewAllList';
import LocationList from './pages/LocationList/LocationList';
import Line from './pages/UserVoice/Line';
import News from './pages/News/News';
import {HelmetProvider} from 'react-helmet-async';
import ToursByCategoryTop from "./pages/Tours/ToursByCategoryTop";
import BookingProcess from "./pages/HowTo/BookingProcess";
import CartPage from "./pages/Cart/CartPage";
import CheckoutPage from "./pages/Cart/CheckoutPage";
import CampaignView from "./pages/CampaignView/CampaignView";
import NewsView from "./pages/NewsView/NewsView";
import BlogView from "./pages/BlogView/BlogView";
import PageView from "./pages/PageView/PageView";
import ScrollToTop from "./components/ScrollToTop";
import {useEffect} from "react";
import ConfirmationStep from "./pages/Cart/ConfirmationStep";
import CheckoutForm from "./pages/Cart/CheckoutForm";
import ComboDetails from "./pages/ComboOffers/ComboDetails";
import ComboTours from "./pages/ComboOffers/ComboTours";
import Recommendations from "./pages/Recommendations/Recommendations";
import ToursByCategory from "./pages/Tours/ToursByCategory";
import ToursByLocation from "./pages/ToursByLocation/ToursByLocation";
import Locations from "./pages/Locations/Locations";
import StudentToursByCategory from "./pages/Tours/StudentToursByCategory";
import SpecialOffers from "./pages/SpecialOffers/SpecialOffers";
import GlobalApiError from "./components/GlobalApiError";
import LowestPriceGuarantee from "./pages/LowestPriceGuarantee/LowestPriceGuarantee";
import Wishlist from "./pages/Wishlist/Wishlist";

function GoogleMapsRedirect() {
    useEffect(() => {
        window.location.href =
            "https://www.google.com/maps/place//data=!4m3!3m2!1s0x697867043f6b4ee5:0x4e7f5549287b9505!12e1?source=g.page.default";
    }, []);

    return null;
}

const AppContent = () => {
    const location = useLocation();
    const isReservationPath = /^\/reserve\/\d+$/.test(location.pathname);
    return (
        <>
            {!isReservationPath && (
                <div className="site-header">
                    <StickyAnnouncement/>
                    <Header/>
                </div>
            )}
            <div className={"container"}>

                <GlobalApiError/>
                <Routes>

                    <Route path="/" element={<Main/>}/>
                    <Route path="/tour-category/for-whom" element={<TourList/>}/>
                    <Route path="/tour-category" element={<TourList/>}/>
                    <Route path="/tours/:rezdyId" element={<TourDetailsNew/>}/>
                    {/* <Route path="/reserve/:planId" element={<ReservationDetails tourName='世界遺産グレートバリアリーフ 小型機での遊覧飛行 コアラリーフ旋回！
＜全席窓際席確約 / 空港お送りOK＞' />} /> */}
                    <Route path="/all-tours/" element={<ToursByCategory/>}/>
                    <Route path="/tours/" element={<ToursByCategory/>}/>
                    <Route
                        path="/locations"
                        element={<Locations/>}
                    />
                    <Route
                        path="/tours/location/:slug"
                        element={<ToursByLocation/>}
                    />
                    <Route path="/tours-location/" element={<ToursByLocation/>}/>
                    {/*<Route path="/image-gallery" element={<ImageGallery/>}/>*/}
                    <Route path="/review/:rezdyId" element={<ReviewList/>}/>
                    <Route path="/great" element={<About/>}/>
                    <Route path="/faqs" element={<Faq/>}/>
                    <Route path="/term" element={<Policy/>}/>
                    <Route path="/howto" element={<BookingProcess/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                    <Route path="/contact-us" element={<Contact/>}/>
                    <Route path="/privacy" element={<Privacy/>}/>
                    <Route path="/reviews" element={<ReviewAllList/>}/>
                    <Route
                        path="/cart"
                        element={<CartPage/>}
                    />
                    <Route
                        path="/checkout"
                        element={<CheckoutPage/>}
                    />
                    <Route
                        path="/checkout-form"
                        element={<CheckoutForm/>}
                    />
                    <Route
                        path="/lowest-price-guarantee"
                        element={<LowestPriceGuarantee />}
                    />
                    <Route
                        path="/wishlist"
                        element={<Wishlist />}
                    />
                    {/*<Route path="/categories" element={<CategoryList/>}/>*/}
                    {/*<Route path="/tour-category/act-cat" element={<Navigate to="/categories" replace/>}/>*/}
                    {/*<Route path="/tour-category/for-whom" element={<Navigate to="/tour-category" replace/>}/>*/}
                    {/*<Route path="/special-offers" element={<Navigate to="/all-tours?sale=true" replace />} />*/}
                    <Route path="/special-offers" element={<SpecialOffers slug={"special-offers"}/>}/>
                    <Route path="/student-discount" element={<StudentToursByCategory/>}/>
                    <Route path="/tour-category/locations" element={<Navigate to="/categories/location" replace/>}/>
                    {/*<Route path="/tour-category/tour-operator"*/}
                    {/*       element={<Navigate to="/all-tours?sale=true" replace/>}/>*/}
                    {/*<Route path="/tour-category/maa"*/}
                    {/*       element={<Navigate to="/all-tours?orderBy=popularity" replace/>}/>*/}
                    <Route path="/uservoice/googlemaps" element={<GoogleMapsRedirect/>}/>
                    {/*<Route path="/campaign" element={<CampaignPage/>}/>*/}
                    <Route path="/campaign/multitour" element={<Campaign/>}/>
                    <Route path="/uservoice/line" element={<Line/>}/>
                    {/*<Route path="/category/blog/helitage" element={<Helitage/>}/>*/}
                    {/*<Route path="/category/blog/cairns-otoku" element={<Otoku/>}/>*/}
                    {/*<Route path="/category/blog/nice" element={<Nice/>}/>*/}
                    {/*<Route path="/blog/nice" element={<Nice/>}/>*/}
                    <Route path="/categories/location" element={<LocationList/>}/>
                    {/*<Route path="/blogs" element={<BlogPage/>}/>*/}
                    {/*<Route path="/blog/magazine" element={<BlogMagazine/>}/>*/}
                    {/*<Route path="/blog/magazine/num01" element={<BlogDetail1/>}/>*/}
                    {/*<Route path="/blog/magazine/num02" element={<BlogDetail2/>}/>*/}
                    {/*<Route path="/blog/nice/tourguide-howto-select" element={<BlogDetail3/>}/>*/}
                    {/*<Route path="/blog/nice/otoku-cairns-travel" element={<BlogDetail4/>}/>*/}
                    {/*<Route path="/blog/helitage/kuranda_helitage" element={<BlogDetail5/>}/>*/}
                    {/*<Route path="/blog/helitage/helitage20" element={<BlogDetail6/>}/>*/}
                    {/*<Route path="/blog/helitage/australia_helitage_spot26" element={<BlogDetail7/>}/>*/}
                    {/*<Route path="/cairns-otoku/sim-vodafone" element={<BlogDetail8/>}/>*/}
                    {/*<Route path="/cairns-otoku/cairns-free-wifi" element={<BlogDetail9/>}/>*/}
                    {/*<Route path="cairns-otoku/sim-optus" element={<BlogDetail10/>}/>*/}
                    {/*<Route path="/blog/nice/tour-search-kokoroe" element={<BlogDetail11/>}/>*/}
                    <Route path="/campaign/:id" element={<CampaignView/>}/>
                    <Route path="/combo/:id" element={<ComboDetails/>}/>
                    <Route path="/combo-tours" element={<ComboTours/>}/>
                    <Route path="/tour-category/:slug" element={<ToursByCategoryTop/>}/>
                    <Route path="/news/:id" element={<NewsView/>}/>
                    <Route path="/blog/:id" element={<BlogView/>}/>
                    <Route path="/page/:id" element={<PageView/>}/>
                    {/*<Route path="/campaign/【2025限定！】ケアンズツアー学生割引" element={<Campaign1/>}/>*/}

                    {/*<Route path="/campaign/グリーン島100周年キャンペーン" element={<Campaign2/>}/>*/}
                    {/*<Route path="/campaign/【2024年4月限定！】キュランダ＆パロネラパーク" element={<Campaign3/>}/>*/}
                    {/*<Route path="/campaign/【期間限定！】複数割引キャンペーン！" element={<Campaign4/>}/>*/}
                    {/*<Route path="/campaign/団体・社員旅行のお得なキャンペーン" element={<Campaign5/>}/>*/}
                    <Route path="/news" element={<News/>}/>
                    {/*<Route path="/campaign/cairns_sp" element={<Campaign11/>}/>*/}
                    {/*<Route path="/news/キュランダ列車に関するお知らせ" element={<News1/>}/>*/}
                    {/*<Route path="/news/camp-attention" element={<News2/>}/>*/}
                    {/*<Route path="/news/google-review" element={<News3/>}/>*/}
                    {/*<Route path="/campaign/nsw-fire-trouble" element={<Campaign12/>}/>*/}
                    {/*<Route path="/campaign/sns-campaign02" element={<Campaign13/>}/>*/}
                    {/*<Route path="/campaign/sns-campaign03" element={<Campaign14/>}/>*/}
                    {/*<Route path="/booking-details" element={<BookingDetailsPage/>}/>*/}
                    <Route path="/booking-confirmed" element={<ConfirmationStep/>}/>
                    <Route path="/recommendations" element={<Recommendations/>}/>
                    {/* Must be last */}
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>

                <Footer/>
            </div>
        </>
    );
};

const App = () => (
    <HelmetProvider>

        <Router>
            <ScrollToTop/>
            <AppContent/>
        </Router>
    </HelmetProvider>
);

export default App;
